import styled from "styled-components";
import { FormControlLabel } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const StyledFormControlLabel = styled(FormControlLabel)`
    && {
        margin-left: 0;
        margin-right: 0;

        &,
        .MuiFormControlLabel-label {
            color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
            //styleName: text/Inter Regular 12px;

            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 17px;
            letter-spacing: 0px;
            text-align: left;

            margin-left: 0;
            margin-right: 0;
        }

        .MuiButtonBase-root {
            padding: 0;
            margin-right: 8px;
        }

        .MuiSwitch-root {
            margin-right: 5px;
        }
    }
`;
